import React from "react";
import Select from "react-select";

/**
 * Employees Select Box
 */
const QuestAutocompleteSelect = ({ options, value, onChange }) => {
  return (
    <Select
      className="select-quest"
      classNamePrefix="manager-select"
      name="quest"
      placeholder="Select quest..."
      value={value}
      valueKey={"id"}
      labelKey={"name"}
      onChange={onChange}
      options={options}
    />
  );
};

export default QuestAutocompleteSelect;
